<template>
  <div :style="styles.base">
    <template v-if="showLogin">
      <div :class="getCss('login')" v-if="isLogin" :style="styles.fontStyle">
        <div>
          你好，
          <template>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && isWX " v-html="userName"></span>
            <span :class="getCss('userinfo-text')" v-if="!isRoleReady && !isWX" v-text="userName"></span>
            <span :class="getCss('userinfo-text')">{{partitionName}}</span>
            <span :class="getCss('userinfo-text')">{{roleName}}</span>
          </template>
        </div>
        <div>
          <a
            v-if="!configurationData.disableBindQQ"
            :class="getCss('userinfo-text-button')"
            @click="handleBindQQ"
            >【绑定QQ】</a
          >
          <a
            v-if="showRole"
            :class="getCss('userinfo-text-button')"
            @click="handleBindRole"
            >【{{ userBindText }}】</a
          >
          <a
            v-if="!configurationData.disableRewardRecord"
            :class="getCss('userinfo-text-button')"
            @click="handleClaimRecord"
            >【领奖记录】</a
          >
          <a
            :class="getCss('userinfo-text-button')"
            v-if="showLogout"
            @click="handleLogout"
            >【注销】</a
          >
        </div>
      </div>
      <div :class="getCss('login')" v-else :style="styles.fontStyle">
        你好，请
        <template v-if="isWX">
          <span>
            <a id="ptLoginBtn" @click="loginByQQ">【QQ登录】</a>
          </span>
          <!-- 如果是端游的 不显示微信登录并且 禁止微信登录         -->
          <span v-if="!isClientGame">
            或
            <a id="wxloginBtn" @click="loginByWx">【微信登录】</a>
          </span>
        </template>
        <template v-else>
          <span>
            <a id="ptLoginBtn" @click="loginByQQ">【QQ登录】</a>
          </span>
        </template>
      </div>
    </template>
    <!-- 绑定QQ弹窗 -->
    <c-base-dialog
      :option="bindQQdialogStyle"
      @close="closeBindQQModal()"
      v-transfer-dom
      v-model="showBindQQPop"
      @confirm="submitBindQQ"
      @cancel="closeBindQQModal"
    >
      <!-- <template slot="header">
        <p :class="getCss('header-title')">绑定获奖QQ</p>
      </template> -->
      <template slot="body">
        <div>
          <input
            type="number"
            :class="getCss('input')"
            v-model="bindQQNum"
            placeholder="请填写QQ号"
          />
          <input
            type="number"
            :class="getCss('input')"
            v-model="bindQQNumConfirm"
            placeholder="请再次填写QQ号"
          />
          <p :class="getCss('desc')">
            活动涉及Q币奖励，请正确填写您的<br />获奖号码
          </p>
        </div>
      </template>
    </c-base-dialog>
    <!-- 已绑定QQ -->
    <c-base-dialog
      :option="showQQdialogStyle"
      @close="closeQQModal()"
      v-transfer-dom
      v-model="showQQPop"
    >
      <template slot="body">
        <div>
          <p :class="getCss('bound-qq')">{{boundQQNum}}</p>
        </div>
      </template>
    </c-base-dialog>
    <!-- 已绑定大区 -->
    <c-base-dialog
      :option="showAreadialogStyle"
      @close="closeAreaPop()"
      v-transfer-dom
      v-model="showAreaPop"
    >
      <template slot="body">
        <div>
          <p :class="getCss('bound-qq')">大区：{{ partitionName }}</p>
          <p :class="getCss('bound-qq')">角色：{{roleName}}</p>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import {
  componentBaseMixin,
  common,
  baseComponents,
} from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
export default {
  name: 'CShanxianUserArea',
  components: { [CDialog.name]: CDialog },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-user-area-',
      showSwitchLogin: false,
      showControl: false,
      showBindQQPop: false,
      showQQPop: false,
      bindQQNum: '',
      bindQQNumConfirm: '',
      boundQQNum: '',
      showAreaPop: false,
    };
  },
  computed: {
    // 浏览器内不显示登录
    showLogin() {
      if (this.$isInEditor) {
        return true;
      }
      // if (!this.$platform.isQQ && !this.$platform.isWX && !this.$ast.isAPP() && !this.isTgclubApp) {
      //   return false;
      // }
      return true;
    },
    isTgclubApp() {
      return !!window.navigator.userAgent.match(/tgclub/i);
    },
    // 端游判断
    isClientGame() {
      return this.$actInfo && this.$actInfo.game_type === 1;
    },

    isWX() {
      if (this.$actInfo && this.$ast.isAPP()) {
        return common.tool.getCookie('acctype') === 'wx';
      }
      return this.$platform.isWX;
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    showRole() {
      console.log('this.isRoleStatusValid', this.isRoleStatusValid);
      console.log('this.actInfo.extendConfig.forceRole', this.actInfo.extendConfig.forceRole);console.log('this.actInfo', this.actInfo);
      return this.isRoleStatusValid && this.actInfo.extendConfig.forceRole;
    },
    disableLogout() {
      return this.$actInfo && this.$ast.isAPP();
    },
    userBindText() {
      return this.isRoleReady ? '更改绑定' : '绑定角色';
      // return '绑定大区';
    },
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    partitionName() {
      return this.isRoleReady
        ? common.tool.Base64.decode(this.roleInfo.partition_name || '')
        : '';
    },
    roleName() {
      return this.isRoleReady
        ? common.tool.Base64.decode(this.roleInfo.role_name || '')
        : '';
    },
    showLogout() {
      // return this.$actInfo && !this.$ast.isAPP();
      return false;
    },
    bindQQdialogStyle() {
      return Object.assign({}, this.dialogConfig, {
        header: '绑定获奖QQ',
        fotter: true,
        height: 'auto',
        confirm: true,
        cancel: true,
      });
    },
    showQQdialogStyle() {
      return Object.assign({}, this.dialogConfig, {
        header: '绑定成功',
        fotter: false,
        height: 'auto',
      });
    },
    showAreadialogStyle() {
      return Object.assign({}, this.dialogConfig, {
        header: '绑定成功',
        fotter: false,
        height: 'auto',
      });
    },
    recordBackground() {
      if (this.configurationData.packageClaimBackgroundImage) {
        return `url(${this.configurationData.packageClaimBackgroundImage})`;
      }
      return this.dialogConfig.dialogStyle.backgroundImage;
    },
    recordCloseBackground() {
      if (this.configurationData.packageClaimCloseImage) {
        return `url(${this.configurationData.packageClaimCloseImage})`;
      }
      return this.dialogConfig.closeStyle.backgroundImage;
    },
  },
  mounted() {
    console.log(
      'version 1.0.10 spark user area  configurationData=',
      this.configurationData,
    );
    this.initialize();
  },
  methods: {
    initialize() {
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '02', '03');
      const prevId = common.tool.getQueryparams('prev_id') ? common.tool.getQueryparams('prev_id') : '' ;
      console.log('prev_id', prevId);
      const obj = {};
      if (prevId !== '') {
        obj.prev_id = prevId;
      }
      this.$pluginSparkReport.sparkBaseReportMerge(this.pageInfo.canvasConfig.reportPv, '2014', '00001', '02', '01', obj);
      // 用户登陆
      this.$eventBus.$onLogined(this.handleLogin);
      console.log('showLogin', this.showLogin);
    },
    async loginByQQ() {
      if (!this.$ast.isAPP() && this.configurationData.inside === true) {
        this.$ast.gotoAPP();
        return;
      }

      if (!this.isLogin) {
        if (!this.$ast.isAPP()) {
          this.login({
            loginType: 'qq',
          });
        } else {
          window?.SX_WEB.auth.login('qc');
        }
        return;
      }
      // if (!this.isLogin) {
      //   window.SX_WEB.auth.login('qc');
      //   return;
      // }
      // if (!this.isLogin && this.isClientGame) {
      //   window.SX_WEB.auth.login('qc');
      //   return;
      // }
      // this.login({
      //   loginType: 'qq',
      // });
    },
    async loginByWx() {
      if (!this.$ast.isAPP() && this.configurationData.inside === true) {
        this.$ast.gotoAPP();
        return;
      }
      if (this.isClientGame) {
        this.$alert({ msg: '该活动仅限QQ用户参与，请重新切换账号' });
        return;
      }
      this.login({
        loginType: 'wx',
      });
    },
    async handleLogout() {
      this.logout();
    },

    async handleLogin() {
      this.$pluginSparkReport.sparkBaseReport(this.pageInfo.canvasConfig.reportPv, '2500', '00001', '01', '01');
      // if (this.$ast.isAPP()) {
      // 自动绑定角色
      if (this.actInfo.extendConfig.forceRole && this.isRoleStatusValid) {
        this.checkRoleInfo();
      }
      // 查询绑定QQ
      if (!this.configurationData.disableBindQQ) {
        this.queryBindQQ();
      }
      // }
    },

    async handleBindRole() {
      // if (!this.$ast.isAPP()) {
      //   await this.$ast.gotoAPP();
      //   return;
      // }
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '05');
      // if (this.isRoleReady) {
      //   // 已绑定
      //   console.log('show role', this.roleInfo);
      //   this.showAreaPop = true;
      //   return;
      // }
      // if (!this.$ast.isAPP() && this.actInfo.extendConfig.forceRole && this.isRoleStatusValid) {
      //   await this.checkRoleInfo();
      // }
      baseComponents.gameRoleSelect
        .showGameRoleSelect(this.currentGameCode || this.actInfo.game_code, {})
        .then((roleInfo) => {
          console.log('select role=', roleInfo);
          this.saveCurrentRole({
            isRoleReady: true,
            roleInfo,
          });
        });
    },
    async handleClaimRecord() {
      // if (!this.$ast.isAPP()) {
      //   await this.$ast.gotoAPP();
      //   return;
      // }
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '06');
      baseComponents.pacakgeClaimRecords.showPackageClaimRecords(
        this.actInfo.game_code,
        {
          hidePackageIds: (
            this.configurationData.hidePackageIdshidePackageIds || ''
          ).split(','),
          params: {
            activity_id: this.actInfo.activity_id.toString(),
            business_id: this.actInfo.ast,
          },
          pageSize: this.configurationData.pageSize ? this.configurationData.pageSize : 6,
          option: {
            header: false,
            footer: false,
            height: this.configurationData.tcheight ? this.configurationData.tcheight : '3.6rem',
            width: '7.2rem',
            closeLocation: this.dialogConfig.closeLocation,
            close: true,
            dialogStyle: Object.assign(
              {},
              {
                color: this.configurationData.recordsFontColor || '#000000',
                // backgroundColor: '#ffffff',
                borderRadius: '0.15rem',
                lineHeight: this.configurationData.lineHeight ? this.configurationData.lineHeight : 1.2,
                backgroundImage: this.recordBackground,
              },
            ),
            closeStyle: Object.assign(
              {},
              {
                backgroundImage: this.recordCloseBackground,
              },
            ),
          },
        },
      );
    },
    async handleBindQQ() {
      // if (!this.$ast.isAPP()) {
      //   this.$ast.gotoAPP();
      //   return;
      // }
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '04');
      console.log('handleBindQQ -----');
      console.log('this.boundQQNum', this.boundQQNum);
      if (this.boundQQNum !== '') {
        this.showQQPop = true;
        return;
      }
      this.showBindQQPop = true;
    },
    closeBindQQModal() {
      this.showBindQQPop = false;
    },
    closeQQModal() {
      this.showQQPop = false;
    },
    closeAreaPop() {
      this.showAreaPop = false;
    },
    async submitBindQQ() {
      if (this.bindQQNum === '' || this.bindQQNumConfirm === '') {
        this.$alert({ msg: '请输入QQ号' });
        return;
      }
      if (!this.isQQ(this.bindQQNum) || !this.isQQ(this.bindQQNumConfirm)) {
        this.$alert({ msg: '请输入正确的QQ号' });
        return;
      }
      if (this.bindQQNum !== this.bindQQNumConfirm) {
        this.$alert({ msg: '两次输入的账号不一致' });
        return;
      }
      const { submitBindQQFlowId } = await this.configurationData;
      if (submitBindQQFlowId <= 0) return;
      console.log(submitBindQQFlowId);
      // 提交 783
      const res = await this.flowRequest({
        flowId: submitBindQQFlowId,
        params: {
          data: JSON.stringify({
            qq: this.bindQQNum,
            // 兼容新条件
            account: this.bindQQNum,
          }),
        },
      });
      console.log('bind qq res', res);
      const { ret, msg, data } = res;

      if (ret !== 0 || data.ret !== 0) {
        this.$alert({ msg: msg || '绑定失败，请稍后再试' });
        return;
      }
      this.boundQQNum = this.bindQQNum;
      this.showBindQQPop = false;
      this.$alert({ msg: '绑定成功' });
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '06', '01');
    },
    isQQ(str) {
      const reg = /^[1-9][0-9]{4,9}$/gim;
      if (reg.test(str)) {
        return true;
      }
      return false;
    },
    async queryBindQQ() {
      const { queryBindQQFlowId } = await this.configurationData;
      if (queryBindQQFlowId <= 0) return;
      const res = await this.flowRequest({
        flowId: queryBindQQFlowId,
      });
      if (res.ret === 0 && res.data.bingingStatus === 1) {
        this.boundQQNum = res.data.account;
      }
      console.log('query bind qq res', res);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.pop-login .qq-login {
  margin-right: 90px;
  display: inline-block;
  width: 145px;
  height: 145px;
  background: url(https://act.xinyue.qq.com/activity/ingame/10009/7625d4358e727be901f2fa8fe4c19653.png)
    no-repeat center top;
}

.pop-login .wechat-login {
  display: inline-block;
  width: 145px;
  height: 145px;
  background: url(https://act.xinyue.qq.com/activity/ingame/10009/685e8ab1c56cbc685b97f5ec9d37f502.png)
    no-repeat center top;
}
</style>
